import React, { useState } from "react";

import { Tab } from "clearsense-ui/components";

import DetailsTable from "./DetailsTable";
import HistoryTable from "./HistoryTable";

const Tabs = ({
  isLoading,
  rules,
  userPermissions,
  handleEditClick,
  setDeleteRule,
  handleTableChange,
  paginationProps,
}) => {
  const [activeTab, setActiveTab] = useState("details");

  return (
    <div>
      <Tab style="secondary">
        <Tab.Item
          active={activeTab === "details"}
          onClick={() => setActiveTab("details")}
        >
          Details
        </Tab.Item>
        <Tab.Item
          active={activeTab === "history"}
          onClick={() => setActiveTab("history")}
        >
          History
        </Tab.Item>
      </Tab>
      <div className="h-[calc(100vh-540px)]">
        {activeTab === "details" && (
          <DetailsTable
            isLoading={isLoading}
            rules={rules}
            userPermissions={userPermissions}
            handleEditClick={handleEditClick}
            setDeleteRule={setDeleteRule}
            handleTableChange={handleTableChange}
            paginationProps={paginationProps}
          />
        )}
        {activeTab === "history" && <HistoryTable />}
      </div>
    </div>
  );
};

export default Tabs;
